import { Fragment } from 'solid-js/h/jsx-runtime'

import { createSolidComponent } from '../solid-component-lib'

// 视图容器
export const CoverImage = /* @__PURE__ */ createSolidComponent('taro-cover-image-core')
export const CoverView = /* @__PURE__ */ createSolidComponent('taro-cover-view-core')
export const MatchMedia = /* @__PURE__ */ createSolidComponent('taro-match-media-core')
export const MovableArea = /* @__PURE__ */ createSolidComponent('taro-movable-area-core')
export const MovableView = /* @__PURE__ */ createSolidComponent('taro-movable-view-core')
export const PageContainer = /* @__PURE__ */ createSolidComponent('taro-page-container-core')
export const RootPortal = /* @__PURE__ */ createSolidComponent('taro-root-portal-core')
export const ScrollView = /* @__PURE__ */ createSolidComponent('taro-scroll-view-core')
export const ShareElement = /* @__PURE__ */ createSolidComponent('taro-share-element-core')
export const Swiper = /* @__PURE__ */ createSolidComponent('taro-swiper-core')
export const SwiperItem = /* @__PURE__ */ createSolidComponent('taro-swiper-item-core')
export const View = /* @__PURE__ */ createSolidComponent('taro-view-core')

// 基础内容
export const Icon = /* @__PURE__ */ createSolidComponent('taro-icon-core')
export const Progress = /* @__PURE__ */ createSolidComponent('taro-progress-core')
export const RichText = /* @__PURE__ */ createSolidComponent('taro-rich-text-core')
export const Text = /* @__PURE__ */ createSolidComponent('taro-text-core')

// 表单组件
export const Button = /* @__PURE__ */ createSolidComponent('taro-button-core')
export const Checkbox = /* @__PURE__ */ createSolidComponent('taro-checkbox-core')
export const CheckboxGroup = /* @__PURE__ */ createSolidComponent('taro-checkbox-group-core')
export const Editor = /* @__PURE__ */ createSolidComponent('taro-editor-core')
export const Form = /* @__PURE__ */ createSolidComponent('taro-form-core')
export const Input = /* @__PURE__ */ createSolidComponent('taro-input-core')
export const KeyboardAccessory = /* @__PURE__ */ createSolidComponent('taro-keyboard-accessory-core')
export const Label = /* @__PURE__ */ createSolidComponent('taro-label-core')
export const Picker = /* @__PURE__ */ createSolidComponent('taro-picker-core')
export const PickerView = /* @__PURE__ */ createSolidComponent('taro-picker-view-core')
export const PickerViewColumn = /* @__PURE__ */ createSolidComponent('taro-picker-view-column-core')
export const Radio = /* @__PURE__ */ createSolidComponent('taro-radio-core')
export const RadioGroup = /* @__PURE__ */ createSolidComponent('taro-radio-group-core')
export const Slider = /* @__PURE__ */ createSolidComponent('taro-slider-core')
export const Switch = /* @__PURE__ */ createSolidComponent('taro-switch-core')
export const Textarea = /* @__PURE__ */ createSolidComponent('taro-textarea-core')

// 导航
export const FunctionalPageNavigator = /* @__PURE__ */ createSolidComponent('taro-functional-page-navigator-core')
export const Navigator = /* @__PURE__ */ createSolidComponent('taro-navigator-core')
export const NavigationBar = /* @__PURE__ */ createSolidComponent('taro-navigation-bar-core')

// 媒体组件
export const Audio = /* @__PURE__ */ createSolidComponent('taro-audio-core')
export const Camera = /* @__PURE__ */ createSolidComponent('taro-camera-core')
export const Image = /* @__PURE__ */ createSolidComponent('taro-image-core')
export const LivePlayer = /* @__PURE__ */ createSolidComponent('taro-live-player-core')
export const LivePusher = /* @__PURE__ */ createSolidComponent('taro-live-pusher-core')
export const Video = /* @__PURE__ */ createSolidComponent('taro-video-core')
export const VoipRoom = /* @__PURE__ */ createSolidComponent('taro-voip-room-core')

// 地图
export const Map = /* @__PURE__ */ createSolidComponent('taro-map-core')

// 画布
export const Canvas = /* @__PURE__ */ createSolidComponent('taro-canvas-core')

// 开放能力
export const Ad = /* @__PURE__ */ createSolidComponent('taro-ad-core')
export const AdCustom = /* @__PURE__ */ createSolidComponent('taro-ad-custom-core')
export const OfficialAccount = /* @__PURE__ */ createSolidComponent('taro-official-account-core')
export const OpenData = /* @__PURE__ */ createSolidComponent('taro-open-data-core')
export const WebView = /* @__PURE__ */ createSolidComponent('taro-web-view-core')

// 页面属性配置节点
export const PageMeta = /* @__PURE__ */ createSolidComponent('taro-page-meta-core')

// 其他
export const Block = Fragment
export const CustomWrapper = /* @__PURE__ */ createSolidComponent('taro-custom-wrapper-core')
